// mexicoV2Language.ts
// ─── Astria Mexico v2 — self-contained EN/ES language toggle ──────────────
// Scoped entirely to this feature — does NOT touch the app-wide i18next
// setup (src/i18n.ts) or any other country lane. Persists only the Mexico
// V2 screen's own language choice, independent of the account's global
// `preferredLanguage`.
import { useCallback, useEffect, useState } from "react";

export type MexicoV2Lang = "en" | "es";

const STORAGE_KEY = "astriaMexicoV2Lang";

export function getStoredMexicoV2Lang(): MexicoV2Lang {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "en" || stored === "es") return stored;
  } catch {
    // localStorage unavailable — fall through to default
  }
  return "es";
}

export function useMexicoV2Language(): [
  MexicoV2Lang,
  (lang: MexicoV2Lang) => void,
] {
  const [lang, setLangState] = useState<MexicoV2Lang>(getStoredMexicoV2Lang);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, lang);
    } catch {
      // ignore
    }
  }, [lang]);

  const setLang = useCallback((next: MexicoV2Lang) => {
    setLangState(next);
  }, []);

  return [lang, setLang];
}
